import { SavingsAccountMetadata } from '@square/dashboard-protos/models/squareup/banking/account_model';

// URLs
export const SAVINGS_ONBOARDING_LINK = '/savings/signup';
export const DASHBOARD_URL = '/dashboard';
export const SAVINGS_URL = '/dashboard/balances/folders';
export const BALANCES_URL = '/dashboard/balances';
export const SAVINGS_SETTINGS_URL = '/dashboard/balances/folders/settings';
export const GENERIC_SUPPORT_URL = 'https://squareup.com/help/article/7418-square-savings-faq';
export const FOLDERS_SUPPORT_URL = 'https://squareup.com/help/ca/en/article/8055-manage-balance-folders';
export const AGREEMENTS_URLS = {
  depositAccountLink: 'https://squareup.com/legal/general/savings',
  privacyPolicyLink: 'https://squareup.com/legal/general/privacy',
  eSignAgreementLink: 'https://squareup.com/legal/general/sign',
  termsOfServiceLink: 'https://squareup.com/legal/general/ua'
};
export const DEFAULT_WITHHOLDING_BPS = 10_00;
export const TAX_DEFAULT_WITHHOLDING_BPS = 10_00;
export const RAINY_DAY_DEFAULT_WITHHOLDING_BPS = 5_00;
export const MAX_WITHHOLDING_BPS = 75_00;
export const MIN_WITHHOLDING_BPS = 50;
export const MAX_TARGET_AMOUNT = 21000000_00;

// Bitcoin
export const SATOSHI_ABBREVIATION_THRESHOLD = 1_000_000; // Threshold to abbreviate large satoshi number
export const BITCOIN_TO_SATOSHI = 100_000_000;
export const SAVINGS_CATEGORIES_TO_ENUMS = {
  Custom: SavingsAccountMetadata.Category.CUSTOM,
  RainyDay: SavingsAccountMetadata.Category.RAINY_DAY,
  Tax: SavingsAccountMetadata.Category.TAX,
  Payroll: SavingsAccountMetadata.Category.PAYROLL,
  Rent: SavingsAccountMetadata.Category.RENT,
  Expense: SavingsAccountMetadata.Category.EXPENSE,
  Retirement: SavingsAccountMetadata.Category.RETIREMENT,
  Profit: SavingsAccountMetadata.Category.PROFIT,
  VehicleGas: SavingsAccountMetadata.Category.VEHICLE_GAS,
  Giving: SavingsAccountMetadata.Category.GIVING,
  Education: SavingsAccountMetadata.Category.EDUCATION
};

// These are the keys for the browser's localStorage object that will store the Plaid link
// tokens for OAuth flows. The link tokens need to be saved in localStorage so that
// when the user comes back to dashboard from the OAuth flow, the original link
// tokens can be retrieved and passed to Plaid or sfs-core.
export const SAVINGS_PLAID_OAUTH_LINK_TOKEN_KEY = 'savingsPlaidOauthLinkToken';
export const SAVINGS_PLAID_GRINGOTTS_SESSION_TOKEN_KEY = 'savingsPlaidGringottsSessionToken';
export const MONEY_INPUT_ID = 'transfer-amount';
export const SAVINGS_ACCOUNT_TYPE = 'Savings';
export const BITCOIN_TREASURY_ACCOUNT_TYPE = 'Bitcoin treasury';

// Local storage keys
export const DISMISS_RECOMMEND_CHECKING_BANNER = 'Checking.hasDismissedRecommendCheckingBanner';
export const DISMISS_SAVINGS_HYSA_APY_BANNER = 'Savings.hasDismissedSavingsHysaBanner';
export const FLEXIBLE_TRANSFER_MODAL_SKIPPED_STEP_IDS = 'Transfers.skippedStepIds';

// Custom Events
export const BANKING_CHECKING_SHOW_GENERIC_ERROR_EVENT = 'banking-checking-show-generic-error';
export const BANKING_MFE_REFRESH_EVENT = 'banking-mfe-refresh';